export class Patient {

    idPaciente: number;//ok
    nomePaciente?: string; //ok
    prontuario: string; //ok
    dataNascimento: string; //ok
    nomeMae: string;//ok
    sexo: string; //ok
    eMail: string;//ok
    codigoIBGE: string;//ok
    municipio: string;//ok
    uf: string;//ok
    cep: string;//ok
    logradouro: string;//ok
    numeroLogradouro: string;//ok
    complemento: string;//ok
    bairro: string;//ok
    telefone: string;//ok
    telefoneCelular: string;//ok
    cpf: string;//ok
    rg: string;//ok
    nacionalidade: string;//ok
    racaPaciente: string;//ok
    idConvenio: number;
    nomeConvenio: string;
    carteiraConvenio: string;
    validadeCarteiraConvenio: string;
    situacao: string;
    estadoCivil: string; //ok

}
